import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthContext } from '../../../state/useAuth'
import { ROUTES } from '../../../constants/routes'
import Spinner from '../../shared/Spinner'

const LoaderStyled = styled.div`
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ProtectedRoutesGuard: FC<PropsWithChildren> = ({ children }) => {
  const { authData, isAuthInitialized } = useAuthContext()
  const location = useLocation()
  const isAuthenticated = authData?.access_token

  if (!isAuthInitialized) {
    return (
      <LoaderStyled>
        <Spinner widthHeight={42} />
      </LoaderStyled>
    )
  }

  if (!isAuthenticated) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`
    return <Navigate to={`${ROUTES.LOGIN}?returnTo=${encodeURIComponent(returnTo)}`} replace />
  }

  return (
    children
      ? <>{children}</>
      : <Outlet />
  )
}

export default ProtectedRoutesGuard
